import { render } from "./delete-confirmation-modal.vue?vue&type=template&id=1fb741a0&ts=true"
import script from "./delete-confirmation-modal.ts?vue&type=script&lang=ts&external"
export * from "./delete-confirmation-modal.ts?vue&type=script&lang=ts&external"

import "./delete-confirmation-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__